import Page from './Page.js';
import Motion from './Motion.js';

/**
 * Class Home
 */
class Home extends Page {


  /**
   * Constructor
   */
  constructor(currentPageId, contactMode){
    super();
    // Properties
    this.content = {};
    this.realisations = [];
    this.articles = [];
    this.currentPageId = currentPageId;
    this.motion = new Motion;
    this.contactMode = contactMode;

    // Listeners
    this.setMagazineHeightListener = this.setMagazineHeight.bind(this);
    this.homeGotoCraftsListener = this.loadCrafts.bind(this);
    this.listenToScrollListener = this.motion.listenToScroll.bind(this);

    if(contactMode){
      this.goToContactListener = this.goToContact.bind(this);
    }

  }


  /**
   * Init
   */
  init() {

  }


  /**
   * Set events listeners
   */
  setEventsListeners() {
    console.log('set home events listeners');
    if (document.getElementById("home-realisations-list")) {
      var realisationsListAnchors = document
      .getElementById("home-realisations-list").getElementsByTagName('a');
      for(var i=0, len=realisationsListAnchors.length; i<len; i++){
        realisationsListAnchors[i].addEventListener(
          'click',
          this.clickOnHomeRealisationsListItem,
          false
        );
        realisationsListAnchors[i].addEventListener(
          'mouseover',
          this.motion.mouseOverRealisationsListItem,
          false
        );
        realisationsListAnchors[i].addEventListener(
          'mouseout',
          this.motion.mouseOutRealisationsListItem,
          false
        );
      }
    }
    if (document.getElementById("home-goto-shops-border-fill-button")) {
      document.getElementById("home-goto-shops-border-fill-button")
        .addEventListener(
        "click",
        this.clickOnHomeGotoShops,
        false
      );
    }
    if (document.getElementById("home-goto-pepzine")) {
      document.getElementById("home-goto-pepzine")
        .addEventListener(
        "click",
        this.clickOnHomeGotoPepzine,
        false
      );
    }
    if (document.getElementById("home-goto-crafts-border-fill-button")) {
      document.getElementById("home-goto-crafts-border-fill-button")
        .addEventListener(
        "click",
        this.homeGotoCraftsListener,
        false
      );
    }
    if (document.getElementById("home-magazine-container")) {
      window.addEventListener(
        'resize',
        this.setMagazineHeightListener,
        false
      );
    }
    window.addEventListener(
      'home_crafts_nav_call',
      this.homeGotoCraftsListener,
      false
    );
    window.addEventListener(
      'scroll',
      this.listenToScrollListener,
      false
    );
    if(this.contactMode){
      window.addEventListener(
        'unlock_screen',
        this.goToContactListener,
        false
      );
    }
  }


  /**
   * Unset event listeners
   */
  unsetEventsListeners() {
    console.log('unset home events listeners');
    if (document.getElementById("home-realisations-list")) {
      var realisationsListAnchors = document
      .getElementById("home-realisations-list").getElementsByTagName('a');
      for(var i=0, len=realisationsListAnchors.length; i<len; i++){
        realisationsListAnchors[i].removeEventListener(
          'click',
          this.clickOnHomeRealisationsListItem,
          false
        );
        realisationsListAnchors[i].removeEventListener(
          'mouseover',
          this.motion.mouseOverRealisationsListItem,
          false
        );
        realisationsListAnchors[i].removeEventListener(
          'mouseout',
          this.motion.mouseOutRealisationsListItem,
          false
        );
      }
    }
    if (document.getElementById("home-goto-shops-border-fill-button")) {
      document.getElementById("home-goto-shops-border-fill-button")
        .removeEventListener(
        "click",
        this.clickOnHomeGotoShops,
        false
      );
    }
    if (document.getElementById("home-goto-pepzine")) {
      document.getElementById("home-goto-pepzine")
        .removeEventListener(
        "click",
        this.clickOnHomeGotoPepzine,
        false
      );
    }
    if (document.getElementById("home-goto-crafts-border-fill-button")) {
      document.getElementById("home-goto-crafts-border-fill-button")
        .removeEventListener(
        "click",
        this.homeGotoCraftsListener,
        false
      );
    }
    if (document.getElementById("home-magazine-container")) {
      window.removeEventListener(
        'resize',
        this.setMagazineHeightListener,
        false
      );
    }
    window.removeEventListener(
      'home_crafts_nav_call',
      this.homeGotoCraftsListener,
      false
    );
    window.removeEventListener(
      'scroll',
      this.listenToScrollListener,
      false
    );
    if(this.contactMode){
      window.removeEventListener(
        'unlock_screen',
        this.goToContactListener,
        false
      );
    }
  }


  /**
   * click on home realisations list item
   */
  clickOnHomeRealisationsListItem(e) {
    e.preventDefault();
    console.log('pass in click on home realisations list item');
    var parts = this.href.split('/');
    var slug = (parts[parts.length - 1])
      ? (parts[parts.length - 1])
      : (parts[parts.length - 2]);
    // @TODO: Refactor a load realisations list item event;
		var e = document.createEvent("CustomEvent");
		e.initCustomEvent('home_realisations_list_item_nav_call', false, false, {
			'realisation': this
		});
    window.dispatchEvent(e);
  }


  /**
   * click on home goto shops
   */
  clickOnHomeGotoShops(e) {
    e.preventDefault();
    console.log('pass in click on home goto shops link');
    // @TODO: Refactor a load realisations event;
		var e = document.createEvent("CustomEvent");
		e.initCustomEvent('home_realisations_nav_call', false, false, {});
    window.dispatchEvent(e);
  }


  /**
   * click on home goto shops
   */
  clickOnHomeGotoPepzine(e) {
    e.preventDefault();
    console.log('pass in click on home goto pepzine link');
    // @TODO: Refactor a load pepzine event;
		var e = document.createEvent("CustomEvent");
		e.initCustomEvent('home_pepzine_nav_call', false, false, {});
    window.dispatchEvent(e);
  }


  /**
   * set magazine height
   */
  setMagazineHeight() {
    this.throttledExec(this.throttledMagazineHeight.bind(this));
  }


  /**
   * Throttled magazine height
   */
  throttledMagazineHeight(){
    console.log('set magazine height');
    if(window.innerWidth >= 1024) {
      document.getElementById('home-magazine-container').style.height
      = document.getElementById('home-content').offsetHeight + "px";
    } else {
      document.getElementById('home-magazine-container').style.height = "auto";
    }
  }


  /**
   * Go to contact
   */
  goToContact(){
    this.motion.scrollToContact();
  }


  /**
   * Go
   */
  go() {
    this.getPageContent();
  }


  /**
   * Get page content
   */
  getPageContent() {
    this.ajax("/wp-json/wp/v2/pages/2").then(
      function(result) {
        var data = JSON.parse(result);
        this.content = data.acf;
        this.getRealisationsContent();
      }.bind(this)
    ).catch(function(msg) {
      console.log(msg);
    });
  }


  /**
   * Get realisations content
   */
  getRealisationsContent() {
    this.ajax(
      "/wp-json/wp/v2/realisations?per_page=6&filter[meta_key]=homepage_display&filter[meta_value]=1"
      ).then(
      function(result) {
        var data = JSON.parse(result);
        if (data.length > 0) {
          for (var item of data) {
            var realisation = [];
            realisation['title'] = item.title.rendered;
            realisation['href'] = item.link;
            realisation['id'] = item.id;
            realisation['thumbnail'] = item["_links"]["wp:featuredmedia"][0]['href'];
            this.realisations.push(realisation);
          }
          this.multipleCallbackMedia(this.realisations.length-1);
        } else {
          this.getPostsContent();
        }
      }.bind(this)
    ).catch(function(msg){
      console.log(msg);
    });
  }


  /**
   * Multiple callback media
   */
  multipleCallbackMedia(index){
    this.ajax(this.realisations[index]["thumbnail"]).then(
      function(result) {
        var thumbnailObject = JSON.parse(result);
        this.realisations[index]['thumbnail'] = thumbnailObject.media_details.sizes.medium_large.source_url;
        if (index > 0){
          index--;
          this.multipleCallbackMedia(index);
        } else {
          // getaway
          this.getPostsContent();
        }
      }.bind(this)
    ).catch(function(msg) {
      console.log(msg);
    });
  }


  /**
   * Get posts content
   */
  getPostsContent(){
    this.ajax("https://pepscreation.com/wp-json/wp/v2/posts?per_page=2").then(
      function(result) {
        var data = JSON.parse(result);
        for (var item of data) {
          this.articles.push(item);
        }
        this.getBlogContent();
      }.bind(this)
    ).catch(function(msg) {
      console.log(msg);
    });
  }


  /**
   * Get blog content
   */
  getBlogContent(){
    console.log("sort articles");
    this.articles.sort(function(a,b){
      return new Date(b.date) - new Date(a.date);
    });
    this.articles = this.articles.slice(0, 2);
    var articles = [];
    var m = new Array("janvier", "fevrier", "mars", "avril", "mai", "juin", "juillet", "aout", "septembre", "octobre", "novembre", "decembre");
    for (var item of this.articles) {
      var article = [];
      article['thumbnail'] = item.acf.image.url;
      article['categories'] = [];
      for (var i = 0; i < item.categories.length; i++) {
        switch (item.categories[i]) {
          case 3:
            article['categories'].push('Food');
            break;
          case 4:
            article['categories'].push('Design');
            break;
          case 12:
            article['categories'].push('Actu');
            break;
          default:
            break;
        }
      }
      article['title'] = item.title.rendered;
      var date = new Date(item.date);
      var dateStr = date.getDate() + " ";
      dateStr += m[date.getMonth()] + " ";
      dateStr += date.getFullYear();
      article['date'] = dateStr;
      article['href'] = item.link;
      articles.push(article);
    }
    this.articles = articles;
    // getaway
    this.display();
  }


  /**
   * Display
   */
  display(data){

    var realisationsListTemplate = ``;
    for (var i=0; i<this.realisations.length; i++) {
      realisationsListTemplate += `
        <li>
        <a
        data-id="${this.realisations[i]['id']}"
        href="${this.realisations[i]['href']}"
        title="${this.realisations[i]['title']}"
        style="background-image:url('${this.realisations[i]['thumbnail']}');"
        >
        <span>${this.realisations[i]['title']}</span>
        <img
        alt="${this.realisations[i]['title']}"
        src="${this.realisations[i]['thumbnail']}">
        </a>
        </li>
        `;
    }


    var blogListTemplate = ``;
    for (var i=0; i<this.articles.length; i++) {
      var articleCategoriesTemplate = ``;
      for (var j=0; j<this.articles[i]['categories'].length; j++){
        if (j > 0){
          articleCategoriesTemplate += `, `;
        }
        articleCategoriesTemplate += `${this.articles[i]['categories'][j]}`;
      }
      blogListTemplate += `<a
        id="home-blog-element-${i+1}"
        class="home-blog-element"
        href="${this.articles[i]['href']}"
        target="_blank">
        <img src="${this.articles[i]['thumbnail']}" alt="${this.articles[i]['title']}">
        <span class="category">${articleCategoriesTemplate}</span>
        <span class="title">${this.articles[i]['title']}</span>
        <span class="date">${this.articles[i]['date']}</span>
        </a>`;
    }

    var template = `
      <div id="home-page" class="page">
      <section id="home-intro">
      <div id="home-intro-anim-container">
      <div id="home-intro-anim">
      <img src="/wp-content/themes/pepscreation/img/home-intro.gif" alt="intro" />
      </div>
      </div>
      <div id="home-intro-text-container">
      <div id="home-intro-text">
      <span>${this.content.home_intro_line_1}</span>
      <h1>${this.content.home_intro_line_2}</h1>
      <p>${this.content.home_intro_text}</p>
      </div>
      </div>
      </section>
      <section id="home-realisations-list" class="realisations-list">
      <ul>`;

    template += realisationsListTemplate;

    template += `
      </ul>
      </section>
      <section id="home-content">
      <div id="home-content-left">
      <div id="home-goto-shops">
      <a id="home-goto-shops-border-fill-button" class="border-fill-button blocked-mobile-border arrow-link" href="javascript:void(0);">
      <svg xmlns="http://www.w3.org/2000/svg">
      <rect
      stroke="#fff"
      stroke-width="5"
      fill="transparent"
      stroke-dasharray="1610"
      stroke-dashoffset="1610"
      height="100%"
      width="100%"
      stroke-opacity="1"/>
      </svg>
      <span>${this.content.home_realisations_link_text}</span>
      </a>
      </div>
      <div id="home-blog-container">
      <div id="home-blog">
      <div id="home-blog-title" class="headline-group">
      <span>${this.content.home_blog_line_1}</span>
      <span class="underlined-headline">${this.content.home_blog_line_2}</span>
      <span>${this.content.home_blog_line_3}</span>
      </div>
      <div id="home-blog-elements">`;

    template += blogListTemplate;

    template += `
      </div>
      </div>
      </div>
      </div>
      <div id="home-magazine-container">
      <div id="home-magazine">
      <div id="home-magazine-title" class="headline-group">
      <span>${this.content.home_pepzine_line_1}</span>
      <span class="underlined-headline">${this.content.home_pepzine_line_2}</span>
      <span>${this.content.home_pepzine_line_3}</span>
      </div>
      <a id="home-goto-pepzine" href="/pepzine" title="Demandez le vôtre">
      <div id="home-magazine-thumbnail">
      <img src="${this.content.home_pepzine_image}" alt="pepzine">
      </div>
      <div id="home-magazine-get" class="headline-group">
      <img src="/wp-content/themes/pepscreation/img/get.png" alt="pepzine">
      <span>${this.content.home_pepzine_link_text}</span>
      </div>
      </a>
      </div>
      </div>
      </section>
      <section id="home-about-container">
      <div id="home-about">
      <div id="home-team">
      <img src="/wp-content/themes/pepscreation/img/team.gif" alt="Peps">
      <p>${this.content.home_about_text}</p>
      </div>
      <div id="home-keyfigures">${this.content.home_about_list}</div>
      <div class="clear"></div>
      <a id="home-goto-crafts-border-fill-button" class="border-fill-button blocked-mobile-border arrow-link" href="javascript:void(0);">
      <svg xmlns="http://www.w3.org/2000/svg">
      <rect
      stroke="#fff"
      stroke-width="5"
      fill="transparent"
      stroke-dasharray="1100"
      stroke-dashoffset="1100"
      height="100%"
      width="100%"
      stroke-opacity="1"/>
      </svg>
      <span>${this.content.home_about_link_text}</span>
      </a>
      </div>
      </section>
      <section id="home-contact-container">
      <div id="home-contact">
      <div id="home-contact-heading" class="headline-group">
      <span>${this.content.home_contact_title_line_1}</span>
      <span class="underlined-headline">${this.content.home_contact_title_line_2}</span>
      <span>${this.content.home_contact_title_line_3}</span>
      </div>
      <div id="home-contact-links">
      <a id="home-contact-mail-link" href="mailto:${this.content.home_contact_email}" title="Contactez-nous par mail.">
      <img src="/wp-content/themes/pepscreation/img/contact-mail.gif" alt="Contact">
      </a>
      <a
      id="home-contact-facebook-link"
      href="${this.content.home_contact_facebook_page_URL}"
      target="_blank"
      title="Rejoignez-nous sur Facebook !">
      <img src="/wp-content/themes/pepscreation/img/contact-fb.png" alt="Facebook">
      </a>
      <div id="home-contact-newsletter">
          <img
            src="/wp-content/themes/pepscreation/img/gif-newsletter.gif"
            alt="Newsletter">
          </div>
      </div>
      <div id="home-contact-address-paris" class="home-contact-address">
      <span class="title">${this.content.home_contact_peps_1_title}</span>
      <span>${this.content.home_contact_peps_1_address_line_1}</span>
      <span>${this.content.home_contact_peps_1_address_line_2}</span>
      <span>${this.content.home_contact_peps_1_address_line_3}</span>
      <a href="mailto:${this.content.home_contact_peps_1_email}" title="mail">${this.content.home_contact_peps_1_email}<a>
      </div>
      <div id="home-contact-address-lyon" class="home-contact-address">
      <span class="title">${this.content.home_contact_peps_2_title}</span>
      <span>${this.content.home_contact_peps_2_address_line_1}</span>
      <span>${this.content.home_contact_peps_2_address_line_2}</span>
      <span>${this.content.home_contact_peps_2_address_line_3}</span>
      <a href="mailto:${this.content.home_contact_peps_2_email}" title="mail">${this.content.home_contact_peps_2_email}<a>
      </div>
      </div>
      </section>
      </div>
      `;

    // set page meta
    document.getElementById(this.currentPageId).setAttribute("id", "home-page-container");
    this.currentPageId = "home-page-container";



    // Send built event
		var e = document.createEvent("CustomEvent");
		e.initCustomEvent('page_built', false, false, {
			'slug': '/',
			'template': template
		});
    window.dispatchEvent(e);
  }


  /**
   * Load Crafts
   */
  loadCrafts(){
    self = this;
    self.ajax("/wp-json/wp/v2/pages?slug=nos-metiers").then(function(result) {
      console.log("crafts data is loaded");
      var data = JSON.parse(result);

      console.log("create mask element");
      var mask = document.createElement("div");
      mask.id = "mask";
      document.body.appendChild(mask);

      console.log("create crafts-container element");
      var craftsContainer = document.createElement("div");
      craftsContainer.id = "crafts-container";
      craftsContainer.innerHTML = data[0].content.rendered;
      craftsContainer.style.opacity = 0; // hide for opacity animation

      console.log("add crafts-container to html");
      document.body.appendChild(craftsContainer);


      // set crafts-container position
      var craftsContainerPosition = 0;
      var windowMargin = window.innerHeight/10;
      if (document.body.offsetHeight-document.body.scrollTop > craftsContainer.offsetHeight + windowMargin) {
        // from the actual position, there is enough space to position the div
        craftsContainerPosition = document.body.scrollTop;
      } else {
        craftsContainerPosition = document.body.offsetHeight - craftsContainer.offsetHeight - windowMargin*2;
      }
      // overwrite crafts container position
      craftsContainer.style.top = craftsContainerPosition + "px";

      console.log("start crafts-container display animation");
      var tl = new TimelineLite();
      tl.to(window, 0.3, {
        scrollTo : { y: craftsContainerPosition - windowMargin, autoKill: true },
        ease: Power1.easeInOut,
      });
      tl.to(craftsContainer, 0.3, {
        opacity: 1
      }, "+=0.3");
      console.log("add close crafts-container listeners");
      mask.addEventListener("click", self.killCrafts, false);
      craftsContainer.addEventListener("click", self.killCrafts, false);
    }).catch(function(msg) {
      console.log(msg);
    });
  }


  /**
   * Kill Crafts
   */
  killCrafts(){
    var self = this;
    var mask = document.getElementById("mask");
    var craftsContainer = document.getElementById("crafts-container");
    console.log("hide mask and crafts-container");
    TweenLite.to(mask, 0.3, {
      opacity: 0
    });
    TweenLite.to(craftsContainer, 0.3, {
      opacity: 0,
      onComplete: function(){
        console.log("remove mask and crafts-container event listeners");
        mask.removeEventListener("click", self.killCrafts, false);
        craftsContainer.removeEventListener("click", self.killCrafts, false);
        console.log("remove mask and crafts-container from document");
        document.body.removeChild(mask);
        document.body.removeChild(craftsContainer);
      }
    });
  }

}

export default Home;

